import React from 'react';
import {
  Row,
  Col,
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
  Checkbox,
  Button,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import countries from 'country-calling-code';
// import countries from 'country-calling-code';
// import PhoneVerify from '../PhoneVerify';

const UserForm = ({
  state,
  profile,
  currentPlan,
  subscriptionPlan,
  handleSave,
  handleValue,
  // handleCountry,
  // handleVerify,
  handleCheck,
  onUpgradePlan,
}) => (
  <Form onSubmit={handleSave} inline>
    <div className="user-info">
      <div className="existing-info">
        <h1>{profile.name}</h1>
        <div className="user-email">{profile.email}</div>
        <p>
          Please provide your full legal name and your current address. This
          information will become part of any agreements that you are involved
          in.
        </p>
        <Row>
          <Col md={12} lg={6}>
            <OverlayTrigger
              overlay={
                <Tooltip id="tooltip-name">
                  You MUST provide your full legal name
                </Tooltip>
              }
              placement="right"
            >
              <FormGroup>
                <ControlLabel>
                  <span className="text-red">*</span>Name:{' '}
                </ControlLabel>
                <FormControl
                  type="text"
                  className="inline"
                  required
                  value={state.fullName}
                  onChange={(e) => handleValue(e, 'fullName')}
                />
              </FormGroup>
            </OverlayTrigger>
          </Col>
          <Col md={12} lg={6}>
            <FormGroup>
              <ControlLabel className="w-110px">
                <span className="text-red">*</span>Country:{' '}
              </ControlLabel>
              <FormControl
                type="text"
                componentClass="select"
                className="inline"
                value={state.country}
                onChange={(e) => handleValue(e, 'country')}
              >
                <option disabled key={-1} value={-1}>
                  Select Country
                </option>
                {countries.map((country, i) => (
                  <option key={i} value={country.country}>
                    {country.country}
                  </option>
                ))}
              </FormControl>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12} lg={6}>
            <FormGroup>
              <ControlLabel>
                <span className="text-red">*</span>Address:{' '}
              </ControlLabel>
              <FormControl
                type="text"
                className="inline"
                required
                value={state.address}
                onChange={(e) => handleValue(e, 'address')}
              />
            </FormGroup>
          </Col>
          <Col md={12} lg={6}>
            <FormGroup>
              <ControlLabel>
                <span className="text-red">*</span>City:{' '}
              </ControlLabel>
              <FormControl
                type="text"
                className="inline"
                required
                value={state.city}
                onChange={(e) => handleValue(e, 'city')}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12} lg={6}>
            <FormGroup>
              <ControlLabel>
                <span className="text-red">*</span>State:{' '}
              </ControlLabel>
              <FormControl
                type="text"
                className="inline"
                required
                value={state.state}
                onChange={(e) => handleValue(e, 'state')}
              />
            </FormGroup>
          </Col>
          <Col md={12} lg={6}>
            <FormGroup>
              <ControlLabel>
                <span className="text-red">*</span>Zip/Postal:{' '}
              </ControlLabel>
              <FormControl
                type="text"
                className="inline"
                required
                value={state.postal}
                onChange={(e) => handleValue(e, 'postal')}
              />
            </FormGroup>
          </Col>
        </Row>
        {/* <Row>
                    <Col md={12} lg={6}>
                        <FormGroup>
                            <ControlLabel><span className="text-red">*</span>Country: </ControlLabel>
                            <FormControl type="text" componentClass="select" className="inline" required
                                value={state.country}
                                onChange={handleCountry}
                            >
                                <option></option>
                                {countries.map((country, i) =>
                                    <option key={i} value={country.country}>
                                        {country.country} ({country.countryCodes[0]})
                                    </option>
                                )}
                            </FormControl>
                        </FormGroup>
                    </Col>
                    <Col md={12} lg={6}>
                        <FormGroup>
                            <ControlLabel className="mobile-label">
                                <span className="text-red">*</span>Mobile#:
                                {state.phoneVerified
                                    ? <span className="text-green verified">&nbsp;&nbsp;( Verified )</span>
                                    : <span className="text-red verified">&nbsp;&nbsp;( Not verified yet )</span>
                                }
                            </ControlLabel>
                            <div className="phone-verify">
                                <FormControl type="text" className="inline"
                                    value={state.tel}
                                    onChange={(e) => handleValue(e, 'tel')}
                                />
                                {state.tel && state.countryCode &&
                                    <PhoneVerify
                                        verified={state.phoneVerified}
                                        phoneNumber={state.tel}
                                        countryCode={state.countryCode}
                                        done={handleVerify}
                                    />
                                }
                            </div>
                        </FormGroup>
                    </Col>
                </Row> */}
        <Row>
          <Col md={12} lg={12}>
            <p className="text-gray">
              Only check the box marked "I will sign on behalf of a company" and
              complete the "Company" and "Title" fields below if you will be
              signing all of your agreements on behalf of a company. Otherwise,
              leave these fields blank.
            </p>
          </Col>
        </Row>
        <Row>
          <Col md={12} lg={6}>
            <FormGroup>
              <ControlLabel>Company: </ControlLabel>
              <FormControl
                type="text"
                className="inline"
                value={state.company}
                onChange={(e) => handleValue(e, 'company')}
              />
            </FormGroup>
          </Col>
          <Col md={12} lg={6}>
            <FormGroup>
              <ControlLabel>Title: </ControlLabel>
              <FormControl
                type="text"
                className="inline"
                value={state.title}
                onChange={(e) => handleValue(e, 'title')}
              />
            </FormGroup>
          </Col>
        </Row>
        <FormGroup>
          <Checkbox
            checked={state.use_company}
            onChange={(e) => handleCheck(e, 'use_company')}
          >
            &nbsp;I will sign on behalf of a company.{' '}
          </Checkbox>
        </FormGroup>
        <FormGroup>
          <ControlLabel className="attorney-label">
            Are you an attorney?{' '}
          </ControlLabel>
          <Checkbox
            checked={state.attorney}
            onChange={(e) => handleCheck(e, 'attorney')}
          >
            &nbsp;Yes
          </Checkbox>
          <div className="helper-text">
            By checking this box, I certify that I am a licensed attorney of
            good standing that is licensed to practice law and that I understand
            Cosynd’s Terms of Use. I understand that only attorneys in good
            standing may alter the text of user-generated agreements on Cosynd’s
            platform.
          </div>
        </FormGroup>
        <FormGroup className="subscription-plan-view">
          <ControlLabel className="attorney-label">
            <span className="text-red">*</span>Subscription Plan:{' '}
          </ControlLabel>
          <div className="subscription-plan">
            <p>{currentPlan}</p>
            <div className="upgrade-plan">
              <Button
                disabled={
                  subscriptionPlan.length === 0 ||
                  subscriptionPlan === 'pro-annual'
                }
                onClick={onUpgradePlan}
              >
                Change Plan
              </Button>
            </div>
          </div>
        </FormGroup>
      </div>
      <div className="edit-info">
        <button type="submit">Save</button>
      </div>
    </div>
  </Form>
);

export default UserForm;



// WEBPACK FOOTER //
// src/components/Profile/UserForm.jsx